import {
  GET_ADMIN_STATIC_DATA,
  SET_ADMIN_STATIC_DATA,
} from "./AdminStaticDataTypes";

const initialState = {
  messageTypeList: [],
  businessUsecaseList: [],
  trainingStatusList: [],
  planTypes: [],
  accountStatusList: [],
};

const AdminStaticDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_STATIC_DATA:
      return {
        ...state,
      };
    case SET_ADMIN_STATIC_DATA:
      return {
        ...state,
        messageTypeList: action.payload.messageTypeList,
        businessUsecaseList: action.payload.businessUsecaseList,
        trainingStatusList: action.payload.trainingStatusList,
        planTypes: action.payload.planTypes,
        accountStatusList: action.payload.accountStatusList,
      };

    default:
      return state;
  }
};

export default AdminStaticDataReducer;
